
const laoExportDRPFilters = {
    // searchStringList: { // PO numbers, Invoice Number, Load Number and Delivery Number
    //   type: "text",
    //   stringToArray: true,
    //   name: "search",
    //   data: null,
    //   region: 'lao'
    // },
    
    availabilityDateRange: { // Availability Date
      type: "date",
      name: "availability_date",
      shortName: 'Availability Date',
      data: null
    },    
    storageLocationList: { // Storage Location
      type: "text",
      name: "storage_location",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },
    priorityWithSeperator: { // Priority
      type: "text",
      name: "priority",
      stringToArray: false,
      stringValue: true, // for chips UI 
      separator: /;/,
      data: null,
      region: 'lao',
      helperText: "helperTextWithSeparator"
    },
    materialNumList: { // Material Number
      type: "text",
      name: "sku",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },
    itemDescWithSeparator: { // Item Desc
      type: "text",
      name: "description",
      stringToArray: false,
      stringValue: true, // for chips UI 
      separator: /;/,
      data: null,
      region: 'lao',
      helperText: "helperTextWithSeparator"
    },
    destSites: { // Destination Plant
      type: "text",
      name: "dest_plant",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },
  };
  
  export default laoExportDRPFilters;